import React from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import { ContentPoliticaPrivacidad } from '../../components/politicaPrivacidad/ContentPoliticaPrivacidad'
import './PoliticaPrivacidad.css'
import HeaderHome from '../../components/headerHome/HeaderHome'

export const PoliticaPrivacidad = () => {

    const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
    const closeMenu = () => {
        if (MenuLateral === true) {
            setMenuLateral(false)
        }
    }

    return (
        <div>
            <div className='headerReservarServicio'>
                <HeaderHome />
            </div>
            <div className='privacy-policy-body'>
                <ContentPoliticaPrivacidad />
            </div>
            <div className='footerReservarServicio'>
                <MiFooter />
            </div>
        </div>
    )
}